module.exports = __webpack_public_path__ + "images/c837b0970616beba46534443d66975a7-IMG_6378.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/kitchen/IMG_6378.jpg
// module id = ./src/assets/images/slides/kitchen/IMG_6378.jpg
// module chunks = 0